import { Skeleton } from '@/components/ui/loading/skeleton';
import { tv } from '@/utils/styles';

const ShipmentLoadingSummary = () => {
  const { base, summary, summaryBlock, details, timeline, timelineCell, fromTo, dates, dateBlock } = styles();

  return (
    <div className={base()}>
      <div className={summary()}>
        <div className={summaryBlock()}>
          <Skeleton className="hidden size-5 md:block" />
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-5 w-32" />
        </div>
        <Skeleton className="hidden h-4 w-32 md:block" />
      </div>
      <div className={details()}>
        <div>
          <div className={timeline()}>
            <Skeleton className={timelineCell()} />
            <Skeleton className={timelineCell()} />
            <Skeleton className={timelineCell()} />
            <Skeleton className={timelineCell()} />
            <Skeleton className={timelineCell()} />
          </div>
          <div className={fromTo()}>
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-40" />
          </div>
        </div>
        <div className={dates()}>
          <div className={dateBlock()}>
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-32" />
          </div>
          <div className={dateBlock({ className: 'md:items-end' })}>
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'rounded border border-grey-300 bg-white',
    summary: 'flex w-full items-center justify-between border-b border-grey-200 px-4 py-6',
    summaryBlock: 'flex flex-col gap-2 md:flex-row',
    details: 'p-4',
    timeline: 'flex w-full flex-col gap-2 py-2 md:flex-row md:items-center md:justify-between',
    timelineCell: 'h-4 w-full md:w-48',
    fromTo: 'flex justify-between',
    dates:
      'mt-4 flex w-full flex-col gap-2 border-t border-dashed border-grey-200 pb-2 pt-4 md:flex-row md:items-center md:justify-between',
    dateBlock: 'flex flex-col gap-2',
  },
});

export { ShipmentLoadingSummary };
